import { removeSpellCheckPopup } from './removeSpellCheckPopup';

/**
 * Create bottom actions section for popup
 * @param {fabric.Textbox} textbox
 * @param {Array} matches
 * @returns {HTMLElement} Actions section element
 */
export function createPopupActions(textbox, matches) {
  // Compose actions section HTML
  const actionsSectionHtml = `
    <div class="spellcheck-actions-section">
      <a href="#" class="report-link d-none">Segnala errore</a>
      <a href="#" class="close-link">Chiudi</a>
    </div>
  `;

  // Create container and set innerHTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = actionsSectionHtml;
  const actionsSection = tempDiv.firstElementChild;

  // Add event listeners
  const reportLink = actionsSection.querySelector('.report-link');
  const closeLink = actionsSection.querySelector('.close-link');

  reportLink.onclick = (e) => {
    e.preventDefault();

    // Mark popup as interacted
    if (window._spellCheckPopupInteracted !== undefined) {
      window._spellCheckPopupInteracted = true;
    }

    removeSpellCheckPopup(true); // Force removal
    // Trigger report dialog
    if (window.handleSpellCheckReport) {
      window.handleSpellCheckReport(textbox, matches);
    }
  };

  closeLink.onclick = (e) => {
    e.preventDefault();

    removeSpellCheckPopup(true); // Force removal
  };

  return actionsSection;
}
